export class StudentInfo {
  id: number;
  userID: number;
  name: string;
  surname: string;
  middleName: string;
}
